import { gql, useQuery } from '@apollo/client';
import {
  GetAuthorQuery,
  GetAuthorQueryVariables,
  GetAuthorsQuery,
  GetAuthorsQueryVariables,
} from '__generated__/queries-web';
import { useCallback } from 'react';
import { useQueryPromise } from 'utils/useQueryPromise';

export const GET_AUTHORS = gql`
  query GetAuthors($where: AuthorFilterInput) {
    authors(first: 100, where: $where, orderBy: name_ASC) {
      id
      name
    }
  }
`;

export const useGetAuthors = () => {
  const queryPromise = useQueryPromise<
    GetAuthorsQuery,
    GetAuthorsQueryVariables
  >(GET_AUTHORS);

  return useCallback(
    (search: string) =>
      queryPromise({ where: { name_contains: search } }).then(
        ({ authors }) => authors,
      ),
    [queryPromise],
  );
};

export const GET_AUTHOR = gql`
  query GetAuthor($where: AuthorUniqueFilterInput!) {
    author(where: $where) {
      id
      name
    }
  }
`;

export const useGetAuthor = (id?: string) =>
  useQuery<GetAuthorQuery, GetAuthorQueryVariables>(GET_AUTHOR, {
    variables: { where: { id } },
    skip: !id,
  });
